/**
 * Lời gọi API Liên hệ (form trên trang giới thiệu) — hợp đồng A0 liên hệ mục 2 và 5.
 * Dữ liệu của nền tảng, chỉ `platform.manage`.
 */
import { chuoiTruyVan, goi } from './goi-chung';

export type TrangThaiLienHe = 'moi' | 'dang_xu_ly' | 'da_xu_ly';

export const CAC_TRANG_THAI_LIEN_HE: TrangThaiLienHe[] = ['moi', 'dang_xu_ly', 'da_xu_ly'];

export interface DongLienHe {
  id: string;
  hoTen: string;
  coQuan: string | null;
  dienThoai: string;
  email: string | null;
  diaPhuong: string | null;
  noiDung: string;
  trangThai: TrangThaiLienHe;
  ghiChuXuLy: string | null;
  /** Người xử lý gần nhất; `ten` có thể null (tài khoản đã xoá tên). */
  nguoiXuLy: { id: string; ten: string | null } | null;
  xuLyLuc: string | null;
  createdAt: string;
}

export interface TrangLienHe {
  items: DongLienHe[];
  total: number;
  page: number;
  pageSize: number;
  /** Số liên hệ "Mới" trên toàn bảng (không theo bộ lọc). */
  soMoi?: number;
}

export interface TuyChonDanhSachLienHe {
  page: number;
  pageSize: number;
  trangThai?: TrangThaiLienHe;
  tuKhoa?: string;
}

/** Thân PATCH: `ghiChuXuLy` '' = xoá ghi chú, vắng = giữ nguyên. */
export interface ThanCapNhatLienHe {
  trangThai: TrangThaiLienHe;
  ghiChuXuLy?: string;
}

export const lienHeApi = {
  danhSach(tc: TuyChonDanhSachLienHe, signal?: AbortSignal): Promise<TrangLienHe> {
    return goi(`/api/v1/platform/lien-he${chuoiTruyVan({ ...tc })}`, { signal });
  },
  capNhat(id: string, than: ThanCapNhatLienHe): Promise<DongLienHe> {
    return goi(`/api/v1/platform/lien-he/${encodeURIComponent(id)}`, { phuongThuc: 'PATCH', than });
  },
  async soMoi(signal?: AbortSignal): Promise<number> {
    const kq = await goi<{ soMoi: number }>('/api/v1/platform/lien-he/so-moi', { signal });
    return kq?.soMoi ?? 0;
  },
};
